export const preguntasFrecuentes = [
    { pregunta: "¿Cómo puedo contactarlos?", respuesta: "Puedes contactarnos por correo o teléfono." },
    { pregunta: "¿Dónde están ubicados?", respuesta: "Estamos en varias ciudades, revisa nuestra sección de sucursales." }
  ];
  
  export const sobreNosotros = [
    { pregunta: "Nuestra Empresa", respuesta: "Somos una empresa comprometida con el cliente." },
    { pregunta: "Nuestros Productos", respuesta: "Ofrecemos una gran variedad de productos de calidad." }
  ];
  